import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/labs")({
  component: () => <Outlet />,
});